import script from "./AddAlbumBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAlbumBox.vue?vue&type=script&setup=true&lang=js"

import "./AddAlbumBox.vue?vue&type=style&index=0&id=17555ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17555ea8"]])

export default __exports__